export const RoleRoutes = {
    CloneRole: "role/Clone",
    DeleteRole: "Customer/DeleteRole",
    SaveRole: "role/Save",
    GetRole: "role",
    ChangeActivationState: "Customer/ChangeRoleActivationState",
    GetRoles: "role/GetRoles"
}
